import React from "react";
import {ButtonStyled} from "./Button.styled";

export function Button(props) {
  return (
    <ButtonStyled>{props.text}</ButtonStyled>
  );
}